import React from 'react';
import { Rate } from 'antd';
import * as T from 'prop-types';
import * as R from 'ramda';

import {
  RateWrapper,
} from './styles';

export const RatePannel = ({ rateValue, withoutPadding }) => {
  const rate = R.is(Number, rateValue) && rateValue.toFixed(1).replace('.', ',');
  const showRate = R.is(Number, rateValue) && !Number.isNaN(rateValue);
  const rateStar = Math.floor(rateValue)
    + (Math.round((rateValue - Math.floor(rateValue))) ? 0.5 : 0.0);

  return (
    <RateWrapper showRate={showRate} withoutPadding={withoutPadding}>
      <Rate disabled defaultValue={2.5} count={5} value={rateStar} allowHalf />{rate}
    </RateWrapper>);
};

RatePannel.defaultProps = {
  rateValue: 0,
  withoutPadding: false,
};

RatePannel.propTypes = {
  rateValue: T.number,
  withoutPadding: T.bool,
};



// WEBPACK FOOTER //
// ./src/components/rate-pannel/index.js